import { isString } from 'lodash-es';

export type InternalUrl = {
  pathname?: string;
  query?: Query;
};

export type Query = Record<string, string>;

export type PathParams = Record<string, string>;

export const toInternalUrl = (url: string | InternalUrl) => {
  if (!isString(url)) {
    return url;
  }

  const [pathname, queryString] = url.split('?');

  const query = Object.fromEntries(new URLSearchParams(queryString));

  return { pathname, query };
};
